import React from 'react'
import { useTranslation} from 'react-i18next';

const Cookies = () => {

    const { t } = useTranslation();

    return (
        <div>
            <div className="container">
            <h1 className='text-center'>{t('Cookies.titre')}</h1>
            <p>{t('Cookies.text')}</p>
            </div>
        </div>
    )
}

export default Cookies
